export const ROUTES = {
  BUSINESS_ACCOUNT: '/business-account',
  CHARITY_ACCOUNT: '/charity-account',
  CHARITY_DASHBOARD: '/dashboard-charity',
}
